import React from 'react';
import { CactusSVGSource } from '../../Assets/Icons/Cactus';

export function CactusSVG() {
  return <img src={CactusSVGSource} alt="" role="presentation" />;
}
